import styled from 'styled-components';
import LateralSpace from '@components/LateralSpace';

const StyledLateralSpace = styled(LateralSpace)`
  display: flex;
  padding: 24px 0 15px 16px;
`;

export default StyledLateralSpace;
